import React from 'react';
import { ContentfulPage } from '../common/ContentfulPage';
import { contentfulPages } from '../../services/constants';

const TermsOfUseScreen = ({ language }) => (
  <ContentfulPage contentfulKey={contentfulPages.TOS} language={language} />
);

export { TermsOfUseScreen };
